export default __webpack_public_path__ + "static/media/avatar.9a0fb40b.svg";